<template>
    <div class="semi-process">
        <!-- 搜索区域 -->
        <div class="search-section">
            <div class="search-form">
                <span class="page-title">半流程-项目管理</span>
                <el-button type="primary" icon="el-icon-plus" @click="handleAddProject" class="add-btn">
                    新增项目
                </el-button>
            </div>
        </div>

        <!-- 数据表格 -->
        <div class="table-section">
            <div class="table-header">
                <span class="table-title">项目列表</span>
                <span class="table-total">共 {{ query.total }} 条</span>
            </div>

            <el-table
                :data="tableData"
                border
                v-loading="loading"
                class="data-table"
            >
                <el-table-column type="index" label="NO." width="60" align="center">
                    <template slot-scope="scope">
                        {{ (query.page - 1) * query.pageSize + scope.$index + 1 }}
                    </template>
                </el-table-column>
                <el-table-column prop="projectName" label="项目名称" min-width="200" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="project-name">
                            <i class="el-icon-document"></i>
                            <span>{{ scope.row.projectName }}</span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="sectionCount" label="标段数量" width="100" align="center">
                    <template slot-scope="scope">
                        <el-tag size="small" type="info">{{ scope.row.sectionCount }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="totalTenderFee" label="标书款(元)" width="130" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.totalTenderFee || '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column prop="totalDrawingDepositFee" label="图纸押金(元)" width="130" align="right">
                    <template slot-scope="scope">
                        {{ scope.row.totalDrawingDepositFee || '0.00' }}
                    </template>
                </el-table-column>
                <el-table-column label="招标文件" width="120" align="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.hasTenderFile === 1 ? 'tag-yes' : 'tag-no'">
                            {{ scope.row.hasTenderFile === 1 ? '有' : '无' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="status" label="状态" width="90" align="center">
                    <template slot-scope="scope">
                        <span :class="scope.row.status === 1 ? 'status-submit' : 'status-draft'">
                            {{ scope.row.status === 1 ? '已提交' : '暂存' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" width="170" align="center">
                    <template slot-scope="scope">
                        {{ scope.row.createTime }}
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="180" align="center">
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="handleDetail(scope.row)" class="action-btn">查看</el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="handleEnterFlow(scope.row)"
                            class="action-btn"
                            v-if="scope.row.status == 1"
                        >
                            进入流程
                        </el-button>
                        <el-button
                            type="text"
                            size="small"
                            @click="handleDelete(scope.row)"
                            class="action-btn delete-btn"
                            v-if="scope.row.status == 0"
                        >
                            删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <!-- 分页 -->
        <div class="pagination-section">
            <el-pagination
                @current-change="handlePageChange"
                :current-page="query.page"
                :page-size="query.pageSize"
                :total="query.total"
                layout="total, prev, pager, next, jumper"
                background
                class="pagination"
            />
        </div>

        <!-- 空状态 -->
        <div class="empty-section" v-if="!loading && tableData.length === 0">
            <div class="empty-content">
                <i class="el-icon-document-remove"></i>
                <p>暂无项目，点击新增项目创建</p>
            </div>
        </div>
    </div>
</template>

<script>
import { Api_GetSemiProcessProjectList, Api_DeleteSemiProcessProject } from '@/api/modules/semiProcess'

export default {
    name: 'SemiProcess',

    data() {
        return {
            loading: false,
            query: {
                page: 1,
                pageSize: 10,
                projectName: '',
                total: 0
            },
            tableData: []
        }
    },

    mounted() {
        this.fetchList()
    },

    methods: {
        async fetchList() {
            this.loading = true
            try {
                const res = await Api_GetSemiProcessProjectList(this.query)
                if (res.code === 200) {
                    this.tableData = res.data.records || []
                    this.query.page = res.data.current || 1
                    this.query.pageSize = res.data.size || 10
                    this.query.total = res.data.total || 0
                } else {
                    this.$message.warning(res.msg || '获取列表失败')
                }
            } catch (err) {
                console.warn('请求异常:', err)
                this.$message.error('网络异常，请稍后重试')
            } finally {
                this.loading = false
            }
        },

        handlePageChange(page) {
            this.query.page = page
            this.fetchList()
        },

        handleAddProject() {
            this.$router.push('/agentHome/addProject')
        },

        handleDetail(row) {
            this.$router.push({
                path: '/agentHome/addProject',
                query: { projectCode: row.projectCode }
            })
        },

        handleEnterFlow(row) {
            this.$router.push({
                path: '/agentHome/projectWorkflow',
                query: {
                    projectName: row.projectName,
                    projectCode: row.projectCode || 'E1101050893002128'
                }
            })
        },

        handleDelete(row) {
            this.$confirm(`确认删除项目「${row.projectName}」吗？`, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const res = await Api_DeleteSemiProcessProject(row.projectCode)
                    if (res.code === 200) {
                        this.$message.success('已删除')
                        this.fetchList()
                    } else {
                        this.$message.error(res.msg || '删除失败')
                    }
                } catch (err) {
                    this.$message.error('删除失败，请重试')
                }
            }).catch(() => {})
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/common-page-styles.less';

.common-list-page-styles(semi-process);

.semi-process {
    // 项目名称
    .project-name {
        display: flex;
        align-items: center;
        gap: 6px;

        i {
            color: #409EFF;
            font-size: 15px;
        }
    }

    // 招标文件标签
    .tag-yes {
        display: inline-block;
        padding: 0 10px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 3px;
        background: #f0f9eb;
        color: #67c23a;
        border: 1px solid #c2e7b0;
    }

    .tag-no {
        display: inline-block;
        padding: 0 10px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 3px;
        background: #f5f5f5;
        color: #909399;
        border: 1px solid #e4e7ed;
    }

    // 状态标签
    .status-submit {
        display: inline-block;
        padding: 0 10px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 3px;
        background: #f0f9eb;
        color: #67c23a;
    }

    .status-draft {
        display: inline-block;
        padding: 0 10px;
        line-height: 24px;
        font-size: 12px;
        border-radius: 3px;
        background: #fdf6ec;
        color: #e6a23c;
    }

    // 删除按钮
    .delete-btn {
        color: #F56C6C !important;

        &:hover {
            background: rgba(#F56C6C, 0.1) !important;
        }
    }

    // 空状态
    .empty-section {
        margin-top: 20px;
        text-align: center;
        padding: 60px 0;
        background: #fff;
        border-radius: 8px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

        .empty-content {
            i {
                font-size: 50px;
                display: block;
                margin-bottom: 12px;
                color: #dcdfe6;
            }

            p {
                font-size: 14px;
                margin: 0;
                color: #909399;
            }
        }
    }
}
</style>